import { useMemo } from "react";
import { Link } from "react-router-dom";
import { ArrowDownUp, CheckIcon, Pencil, Trash2 } from "lucide-react";
// @ts-ignore
import moment from "moment-jalaali";
import { CellContext } from "@tanstack/react-table";

interface ColumnsProps {
  onClickDelete: (data: any) => void;
}

const CargoDeficitFareColumn = ({ onClickDelete }: ColumnsProps) => {
  return [
    {
      header: "وزن",
      accessorKey: "weight",
      enableColumnFilter: false,
    },
    {
      header: () => (
        <span className="flex">
          مبلغ
          <ArrowDownUp size={15} className="text-blue-500 gap-2" />
        </span>
      ),
      accessorKey: "price",
      enableColumnFilter: true,
      cell: (cell: any) => (
        <Link
          to="#!"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "تاریخ ثبت ",
      accessorKey: "create_at",
      enableColumnFilter: false,
    },
    {
      header: "حذف",
      enableColumnFilter: false,
      enableSorting: true,
      cell: (cell: any) => (
        <div className="flex gap-3">
          <Link
            to="#!"
            className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
            onClick={() => {
              const data = cell.row.original;
              onClickDelete(data);
            }}
          >
            <span className="p-1 rounded-sm text-white bg-red-600">حذف </span>
          </Link>
        </div>
      ),
    },
  ];
};

export default CargoDeficitFareColumn;
